import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./index.scss";
import searchTagStore from "../../stores/searchTagStore";
import { useMediaQuery } from "@mui/material";
import paymentStore from "../../stores/paymentStore";
import orderStore from "../../stores/orderStore";
import usersStore from "../../stores/usersStore";
import productStore from "../../stores/productStore";
import categoryStore from "../../stores/categoryStore";
import couponStore from "../../stores/couponStore";
import orderDeliveryStatusTimeStore from "../../stores/orderDeliveryStatusTimeStore";
import addressStore from "../../stores/addressStore";
import productRatingStore from "../../stores/productRatingStore";
import orderReturnRequestStore from "../../stores/orderReturnRequestStore";
import contactUsStore from "../../stores/contactUsStore";
import authStore from "../../stores/authStore";

const Layout = () => {
  const max_width890 = useMediaQuery("(max-width:890px)");
  const max_width790 = useMediaQuery("(max-width:790px)");
  const max_width500 = useMediaQuery("(max-width:500px)");
  const [isOpenSidebar, setIsOpenSidebar] = useState(true);
  const CategoryStore = categoryStore();
  const SearchTagStore = searchTagStore();
  const PaymentStore = paymentStore();
  const OrderStore = orderStore();
  const UsersStore = usersStore();
  const ProductStore = productStore();
  const CouponStore = couponStore();
  const OrderDeliveryStatusTimeStore = orderDeliveryStatusTimeStore();
  const AddressStore = addressStore();
  const ProductRatingStore = productRatingStore();
  const OrderReturnRequestStore = orderReturnRequestStore();
  const ContactUsStore = contactUsStore();
  const AuthStore = authStore();

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    if (AuthStore.loggedIn) {
      await CategoryStore.fetchCategory();
      await SearchTagStore.fetchAllSearchTag();
      await ProductStore.fetchAllProduct();
      await ProductRatingStore.fetchAllRating();
      await PaymentStore.fetchAllPayment();
      await OrderReturnRequestStore.fetchAllOrderReturnRequest();
      await OrderStore.fetchAllOrders();
      await OrderDeliveryStatusTimeStore.fetchAllOrderDeliveryStatusTime();
      await UsersStore.fetchAllUsers();
      await AddressStore.fetchAllUserAddress();
      await CouponStore.fetchAllCoupon();
      ContactUsStore.fetchAllContactUs();
    }
  };

  return (
    <div className="container">
      <Sidebar
        isOpenSidebar={isOpenSidebar}
        setIsOpenSidebar={setIsOpenSidebar}
      />
      <div
        className="mainContent"
        style={{
          marginLeft: isOpenSidebar
            ? max_width500
              ? "20%"
              : max_width790
              ? "15%"
              : max_width890
              ? "10%"
              : "20%"
            : "0",
        }}
      >
        <Navbar
          isOpenSidebar={isOpenSidebar}
          setIsOpenSidebar={setIsOpenSidebar}
        />
        <div className="bodyContent">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
